<template>
    <div>
      <Navbar v-if="$route.name === 'eventmails'" />
      <Breadcrumb v-if="$route.name === 'eventmails'" />
      <div v-if="template_id < 0">
          <div class="row pb-2">
              <div class="col-6">
                  <input
                    class="form-control"
                    v-model="searchText"
                    placeholder="Type to search"
                  />
              </div>
              <div class="col-2">
                  <select class="form-select" v-model="typeFilter">
                    <option value="all">All types</option>
                    <option value="event">Event</option>
                    <option value="newsletter">Newsletter</option>
                  </select>
              </div>
              <div class="col-4 text-end">
                  <button
                    class="btn btn-primary"
                    @click="template_id = 0;template_name = '';template_subject = '';currentTemplateType = '';"
                  >New template</button>
              </div>
          </div>
          <div class="table-responsive">
            <table class="table table-striped table-hover">
              <thead>
                <tr>
                  <th class="col-1" @click="toggleSort('id')" style="cursor: pointer;">
                    ID <span v-if="sortBy === 'id'">{{ sortDesc ? '▼' : '▲' }}</span>
                  </th>
                  <th @click="toggleSort('template_name')" style="cursor: pointer;">
                    Template Name <span v-if="sortBy === 'template_name'">{{ sortDesc ? '▼' : '▲' }}</span>
                  </th>
                  <th>Type</th>
                  <th class="col-1"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in sortedTemplates" :key="item.id" @click="template_get(item)" style="cursor: pointer;">
                  <td>{{ item.id }}</td>
                  <td>{{ item.template_name }}</td>
                  <td>
                    <span class="badge bg-info text-dark" v-if="item.template_type">{{ item.template_type }}</span>
                    <span class="text-muted" v-else>Newsletter</span>
                  </td>
                  <td>
                    <button
                      class="btn btn-primary btn-sm me-2"
                      title="Edit template"
                      @click.stop="template_id=item.id"
                    >
                      <fa-icon name="edit" />
                    </button>
                    <button
                      class="btn btn-secondary btn-sm me-2"
                      title="Duplicate template"
                      @click.stop="template_duplicate(item)"
                    >
                      <fa-icon name="copy" />
                    </button>
                    <button
                      class="btn btn-danger btn-sm me-2"
                      title="Delete template"
                      @click.stop="template_delete(item)"
                    >
                      <fa-icon name="trash" />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
      </div>
      
      <div v-if="template_id >= 0" style="height: 100vh !important">
        <!-- Loading Overlay -->
        <div v-if="saving" class="position-fixed top-0 start-0 w-100 h-100" style="z-index: 1050; background-color: rgba(0,0,0,0.5);">
          <div class="position-absolute top-50 start-50 translate-middle text-center text-white">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>

        <div v-show="templateSaved" class="bg-success text-white py-1 px-2 mb-2">
            Template saved
        </div>
        
        <div class="row mb-4 sticky">
          <label class="col-2 pt-2">Template name:</label>     
          <div class="col-5">
            <input
              v-model="template_name"
              class="form-control"
              autocomplete="off"
            />
          </div>
          <div class="col-5 text-end">
            <button
              class="btn btn-primary me-2"
              @click="template_save"
              :disabled="saving || !editorIsReady"
            >Save template</button>
            <button
              class="btn btn-secondary me-2"
              @click="template_id = -1"
            >Back to list</button>
          </div>
        </div>
        
        <div class="row mb-3">
          <label class="col-2 pt-2">Template e-mail subject:</label>
          <div class="col-5">
            <input
              v-model="template_subject"
              class="form-control"
              autocomplete="off"
            />
          </div>
        </div>
        
        <EmailEditor
          style="height: 80vh !important"
          ref="emailEditor"
          :options="editorOptions"
          @load="editorLoaded"
          @ready="editorReady"
        />
      </div>
    </div>
  </template>
  
  <script>
    /* eslint-disable no-console */
    import EmailEditor from './CustomControls/EmailEditor.vue';
    import Navbar from './Navbar.vue';
    import Breadcrumb from './Breadcrumb.vue';

    const cols = [
        { key: 'id', label: 'ID', sortable: true, tdClass: 'col-1', thClass: 'col-1' },
        { key: 'template_name', label: 'Template Name', sortable: true },
        { key: 'actions', label: '', tdClass: 'col-1', thClass: 'col-1' },
    ];
  
  export default {
    name: 'BulkMailDesign',
    components: {
      EmailEditor,
      Navbar,
      Breadcrumb,
    },
    data() {
      return {
        template_id: -1,
        templates: [],
        loading: false,
        templatecolumns: cols,
        template_name: '',
        template_subject: '',
        searchText: '',
        typeFilter: 'all',
        currentTemplateType: '',
        sortBy: 'template_name',
        sortDesc: true,
          editorTools: { },
          templateSaved: false,
          saving: false,
          editorIsReady: false,
        };
      },
    created() {
      this.templates_get();
    },
    computed: {
      editorOptions() {
        const mergeTags = {
          first_name: {
            name: 'First Name',
            value: '{{firstName}}',
          },
          family_name: {
            name: 'Family Name',
            value: '{{familyName}}',
          },
          email: {
            name: 'Email',
            value: '{{email}}',
          },
        };
        if (this.currentTemplateType && this.currentTemplateType.startsWith('event_')) {
          mergeTags.reference = { name: 'Booking reference', value: '{{reference}}' };
          mergeTags.event_name = { name: 'Event name', value: '{{eventName}}' };
          mergeTags.event_date = { name: 'Event date', value: '{{eventDate}}' };
          mergeTags.event_time = { name: 'Event time', value: '{{eventTime}}' };
          mergeTags.location = { name: 'Location', value: '{{location}}' };
          mergeTags.organizer = { name: 'Organizer', value: '{{organizer}}' };
          mergeTags.seats = { name: 'Number of seats', value: '{{seats}}' };
          mergeTags.attendees = { name: 'Attendees', value: '{{attendees}}' };
          mergeTags.reason = { name: 'Reason', value: '{{reason}}' };
          mergeTags.link = { name: 'Set-password link', value: '{{link}}' };
        } else {
          mergeTags.unsubscribe = { name: 'Unsubscribe link', value: '{{unsubscribe}}' };
        }
        return { mergeTags };
      },
      filteredTemplates() {
        let list = this.templates;
        if (this.typeFilter === 'event') {
          list = list.filter(t => t.template_type && t.template_type.startsWith('event_'));
        } else if (this.typeFilter === 'newsletter') {
          list = list.filter(t => !t.template_type);
        }
        if (this.searchText) {
          const search = this.searchText.toLowerCase();
          list = list.filter(template =>
            template.template_name?.toLowerCase().includes(search) ||
            template.id?.toString().includes(search)
          );
        }
        return list;
      },
      sortedTemplates() {
        const sorted = [...this.filteredTemplates];
        sorted.sort((a, b) => {
          const aVal = a[this.sortBy] ?? '';
          const bVal = b[this.sortBy] ?? '';
          const result = aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
          return this.sortDesc ? -result : result;
        });
        return sorted;
      }
    },
    methods: {
      toggleSort(column) {
        if (this.sortBy === column) {
          this.sortDesc = !this.sortDesc;
        } else {
          this.sortBy = column;
          this.sortDesc = false;
        }
      },
        hideBlockbuilderBranding() {
          const elements = document.querySelectorAll('.blockbuilder-branding');
          elements.forEach(element => {
            element.style.display = 'none';
            element.style.height = '0';
          });
        },
        templates_get() {
          const filter = {
            deleted: {
              operator: '=',
              value: 0,
            }
          }
          this.$store.dispatch('records_readlist', { table_name: 'g_bulkemailtemplates', filter })
            .then((response) => {
              this.templates = response.data.result;
            });
        },
        template_get(item) {
          this.template_id = item.id;
          this.currentTemplateType = item.template_type || '';
        },
        async template_save() {
          const editor = this.$refs.emailEditor && this.$refs.emailEditor.editor;
          if (!editor) {
            alert('The e-mail editor is still loading. Please try again in a moment.');
            return;
          }
          let html = '';
          this.saving = true;
          await new Promise((resolve) => {
            this.$refs.emailEditor.editor.exportHtml((data) => {
              html = data.html;
              resolve();
            });
          });

          this.$refs.emailEditor.editor.saveDesign(async (design) => {
            const data = {
              table_name: 'g_bulkemailtemplates',
              record: {
                template_subject: this.template_subject,
                template_name: this.template_name,
                template_json: JSON.stringify(design),
                template: html,
              },
            }
            if (this.template_id > 0) {
              data.id = this.template_id;
              await this.$store.dispatch('record_put', { id: this.template_id, ...data })
                .then(() => {
                  this.templates_get();
                  this.templateSaved = true;
                  this.saving = false;
                  setTimeout(() => {
                    this.templateSaved = false;
                  }, 2000);
                 });
            } else {
              await this.$store.dispatch('record_post', data)
                .then((response) => {
                  this.templates_get();
                  this.template_id = response.data.id;
                  this.templateSaved = true;
                  this.saving = false;
                  setTimeout(() => {
                    this.templateSaved = false;
                  }, 2000);
                });
            }
          });
        },
        async template_delete(item) {
          if (confirm(`Do you really want to delete the template ${item.template_name}?`)) {
            const record = {
              deleted: 1,
            }
            this.$store.dispatch('record_put', { table_name: 'g_bulkemailtemplates', id: item.id, record })
              .then(() => {
                this.templates_get();
              });
          }
        },
        async template_duplicate(item) {
          this.saving = true;
          await this.$store.dispatch('record_read', { table_name: 'g_bulkemailtemplates', id: item.id })
            .then(async (resp) => {
              let newTemplate = resp.data;
              newTemplate.template_name = `${newTemplate.template_name} (copy)`;
              newTemplate.id = -1;
              const data = {
              table_name: 'g_bulkemailtemplates',
              record: newTemplate,
            }
              await this.$store.dispatch('record_post', data)
                .then(() => {
                  this.templates_get();
                  this.templateSaved = true;
                  this.saving = false;
                  setTimeout(() => {
                    this.templateSaved = false;
                  }, 2000);
                });
          });
        },
        editorLoaded() {
          this.editorIsReady = false;
          this.hideBlockbuilderBranding();
          if (this.template_id === 0) {
            // New template, no need to load
            return;
          }
          this.$store.dispatch('record_read', { table_name: 'g_bulkemailtemplates', id: this.template_id })
            .then((response) => {
              this.template_id = response.data.id;
              this.template_name = response.data.template_name;
              this.template_subject = response.data.template_subject;
              this.currentTemplateType = response.data.template_type || '';
              if (response.data.template_json) {
                try {
                  const design = JSON.parse(response.data.template_json);
                  this.$refs.emailEditor.editor.loadDesign(design);
                } catch (error) {
                  console.error('Error parsing template JSON:', error);
                }
              }
            })
            .catch((error) => {
              console.error('Error loading template:', error);
            });
        },
        editorReady() {
          this.editorIsReady = true;
          this.hideBlockbuilderBranding();
        },
        saveDesign() {
          this.$refs.emailEditor.editor.saveDesign((design) => {
            console.log('saveDesign', design);
          });
        },
        exportHtml() {
          this.$refs.emailEditor.editor.exportHtml((data) => {
            console.log('exportHtml', data);
          });
        },
      },
    };
  </script>
  <style>
    .sticky {
      position: sticky;
      top: 0;
      background-color: white;
      z-index: 1000;
    }
    a.blockbuilder-branding {
      display: none !important;
      height: 0 !important;
    }
</style>
